import { PulseBetProgressPeriodData } from "../PulseBetProgressPeriodData";

/**
* PulseBetProgressData defines the data for the progress bar animation
*
* @typedef PulseBetProgressData
* @type {type}
* @property {periods} periods Collection with the periods in the bet
* @property {startTime} startTime Indicates what is the beggining point of the bet
* @property {endTime} endTime Indicates what is the ending point of the bet
* @property {expiredBetProgressInMilliseconds} expiredBetProgressInMilliseconds Indicates the already passed progress in the bet
*/

export class PulseBetProgressData {
    periods: PulseBetProgressPeriodData[];
    startTime: string;
    endTime: string;
    expiredBetProgressInMilliseconds: number;
    id: string;

    constructor(source: PulseBetProgressData) {
        this.periods = source.periods;
        this.startTime = source.startTime;
        this.endTime = source.endTime;
        this.expiredBetProgressInMilliseconds = source.expiredBetProgressInMilliseconds;
        this.id = source.id;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/PulseBetProgressData/PulseBetProgressData.ts